import { initIDB } from "./";

export const indexedDbDeleteById = (dbName: string, id: unknown) => {
  return new Promise((resolve, reject) => {
    initIDB().then((db) => {
      const txn = (db as any).transaction(dbName, "readwrite");
      const store = txn.objectStore(dbName);

      const query = store.delete(id);

      query.onsuccess = function (event: Event) {
        resolve(event);
      };

      query.onerror = function (event: Event) {
        reject(event);
      };

      txn.oncomplete = function () {
        (db as any).close();
      };
    });
  });
};
